<style scoped >
.filepicker {
  width:100%;
}
</style>
<template>
<v-card >
  <v-card-title class='overline'>
    <v-icon small class='mr-1' >attach_file</v-icon>
    Documents
  </v-card-title>
  <v-divider></v-divider>
  <v-list dense v-if='documents && documents.length > 0' class='pa-0' >
    <v-subheader class='overline' >Attached documents</v-subheader>
    <template v-for='(doc, index) in documents' >
      <v-list-tile
        :key='`doc-${doc.name}-${index}`'
        :href='doc.file' target='_blank' >
        <v-list-tile-avatar >
          <v-btn
            @click.prevent="confirmDeleteFile = true"
            :loading='doc.deleting === true'
            color='error' small icon  ><v-icon small>delete</v-icon></v-btn>
          <v-dialog v-model="confirmDeleteFile" width="300" >
            <v-card>
              <v-card-title class='subheading' >
                Are you sure you want to delete this file?
              </v-card-title>
              <v-card-actions>
                <v-btn @click='confirmDeleteFile = false' flat text >Cancel</v-btn>
                <v-spacer ></v-spacer>
                <v-btn
                  :loading='deleting'
                  @click='deleteFile(doc, index)' color='error' >Delete</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-list-tile-avatar>
        <v-divider class='mr-2' vertical ></v-divider>
        <v-list-tile-content>
          <v-list-tile-title >{{doc.id}}. {{doc.name}}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action >
          <v-icon small>open_in_new</v-icon>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider :key='`div-${doc.name}-${index}`' ></v-divider>
    </template>
  </v-list>
  <v-divider v-if='documents && documents.length > 0' ></v-divider>
  <v-subheader class='overline' >Upload documents</v-subheader>
  <input type='file' id="file" ref="file" @change='setFiles' class='filepicker grey lighten-3 pa-3' multiple />
  <v-divider></v-divider>
  <v-list dense v-if='files' class='pa-0' >
    <v-list-tile v-for='(file, index) in files' :key='`${file.name}-${index}`' >
      <v-list-tile-avatar >
        <v-icon small >cloud_upload</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>{{file.name}}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
  <v-card-actions >
    <!-- <span v-if='uploading'>
      <v-progress-circular size='28' width='2' indeterminate color='amber' class='mr-2' >
      </v-progress-circular>
      Uploading ..
    </span> -->
    <v-btn :disabled='files.length === 0' @click='clearfiles' flat text small >Clear files</v-btn>
    <v-spacer></v-spacer>
    <v-btn
      @click='upload'
      :loading='uploading'
      :disabled='files.length === 0' small color='primary' >
        {{ $tc('upload.button', files.length, {n: files.length}) }}
    </v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'

export default {
  name: 'DocumentList',
  props: {
    noteId: { type: Number, required: true },
    value: { type: Array, default: () => { return [] } }
  },
  data () {
    return {
      documents: [],
      files: [],
      confirmDeleteFile: false,
      uploading: false,
      deleting: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          this.documents = this.value
        }
      }
    },
    documentLength () {
      this.$emit('input', this.documents)
    }
  },
  computed: {
    documentLength () {
      return this.documents.length
    }
  },
  methods: {
    clearfiles () {
      this.$refs.file.value = ''
      this.files = []
    },
    setFiles (file) {
      this.files = this.$refs.file.files
    },
    deleteFile (file, index) {
      Vue.set(file, 'deleting', true)
      let url = this.$metadataguru.baseUrl + '/v3/notes/' + this.noteId + '/document/'
      let headers = JSON.parse(JSON.stringify(this.$metadataguru.headers))
      let method = 'delete'
      let params = {document: file.id}
      this.deleting = true
      axios({url, headers, method, params})
        .then(() => {
          Vue.set(file, 'deleting', false)
          this.deleting = false
          this.documents.splice(index, 1)
          this.confirmDeleteFile = false
        }).catch(() => {
          Vue.set(file, 'deleting', false)
          this.deleting = false
          window.alert('Unable to delete this file')
        })
    },
    upload () {
      // let files = this.$refs.file.files
      for (let i = 0; i < this.files.length; i++) {
        let file = this.files[i]
        if (file) {
          let vm = this
          vm.uploading = true
          let data = new FormData()
          data.append('file', file)
          data.append('name', file.name.substring(0, 50))
          let url = this.$metadataguru.baseUrl + '/v3/notes/' + this.noteId + '/actions/upload/'
          let headers = JSON.parse(JSON.stringify(this.$metadataguru.headers))
          headers['Content-Type'] = 'multipart/form-data'

          axios.post(url, data, { headers })
            .then((res) => {
              vm.uploading = false
              vm.documents.push(res.data)
              vm.clearfiles()
            }).catch(() => {
              vm.uploading = false
            })
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        upload: {
          button: 'Choose files to upload|upload {n} file|upload {n} files'
        }
      },
      es: {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// DocumentList.vue?b69819f2